import { RootState } from "../../../../../redux/store";

export const isItemsLoading = (state:RootState) => state.country.itemsLoading;
export const getItemsSelect = (state:RootState) => state.country.dropDownItems;